module.exports = __webpack_public_path__ + "static/media/postcss.2348d8db.png";